import React from "react";
import { is } from "ramda";
import { dateToHHMM } from "../../shared/utils";

const PassengerLineRender = ({ passengerType, passengers }) => {
    
    if (!Array.isArray(passengers) || passengers.length <= 0) {
        return null;
    }

    return (
        <React.Fragment>
            {
                passengers.map((passenger, index) => {
                    return (
                        <p className="passenger-line" key={`${passengerType}-${index}`}>
                            {passenger.first_name} {passenger.last_name}{passenger.suffix && ` ${passenger.suffix}`}
                        </p>
                    );
                })
            }
        </React.Fragment>
    );
};

const FlightResumeLineRender = ({ flight, passengers, stretch }) => {
    return (
        <React.Fragment>
            <div className="flight-stretch-line">
                <div className="flight-airline-info">
                    <span className="flight-airline-name">
                        <i className={`icon icon-${stretch}`} /> {flight.airline}
                    </span>
                    <span className="flight-airline-number small">
                        ({flight.flightNumber})
                    </span>
                </div>

                <div className="flight-airline-stretchs-info">
                    <div className="flight-departure">
                        <span className="small-title hidden">Partida:</span>
                        <span className="flight-stretch-airport">
                            {dateToHHMM(flight.departureDate)} <span className="iata">{flight.from}</span>
                        </span>
                        {flight.departureDate.substr(0, 10)}
                    </div>
                    <i className="icon icon-arrow" />
                    <div className="flight-arrival">
                        <span className="small-title hidden">Chegada:</span>
                        <span className="flight-stretch-airport">
                            {flight.to} <span className="iata">{dateToHHMM(flight.arrivalDate)}</span>
                        </span>
                        {flight.arrivalDate.substr(0, 10)}
                    </div>
                </div>

                <div className="flight-airline-passengers-info">
                    <span className="small-title">Passageiros:</span>
                    <PassengerLineRender passengers={passengers["adults"]}   passengerType="adults"   />
                    <PassengerLineRender passengers={passengers["children"]} passengerType="children" />
                    <PassengerLineRender passengers={passengers["infants"]}  passengerType="infants"  />
                </div>
            </div>
        </React.Fragment>
    );
};

const FlightResume = ({ passengers, flights })  => {

    if (!is(Object, flights)) {
        return null;
    }

    return (
        <React.Fragment>
            <FlightResumeLineRender flight={flights["outbound"]} stretch="outbound" passengers={passengers} />
            { flights["inbound"] !== undefined && 
                (
                    <FlightResumeLineRender flight={flights["inbound"]}  stretch="inbound"  passengers={passengers} /> 
                )
            }
        </React.Fragment>
    );
};

export default FlightResume;
